const modal = document.querySelector('.custom-modal');
const checkout = document.querySelector('.mobile-button-cart');
const closeButton = document.querySelector('.custom-modal-close');
const modalContent = document.querySelector('#modal-content');

function openModal(contentType, productId) {
  fetchContent(contentType, productId);
  modal.classList.add('open');

  if (contentType === 'item-modal') {
    document.body.style.overflow = 'hidden';
    checkout.classList.add('hidden-checkout');
    initializeSwiper(); 
  }
}

function fetchContent(contentType, productId) {
  const button = event.target.closest('.svg-modal-items');
  const productImages = JSON.parse(button.getAttribute('data-product-images'));
  const productTitle = button.getAttribute('data-product-title');
  const productDescription = button.getAttribute('data-product-description');
  const productPrice = button.getAttribute('data-product-price');
  const shippingAndReturns = button.getAttribute('data-product-shippingReturns');
  const careInstructions = button.getAttribute('data-product-careInstructions');
  const materials = button.getAttribute('data-product-materials');

  const snippetContent = document.querySelector(`#${contentType}-content`).innerHTML;
  modalContent.innerHTML = snippetContent;

  const swiperWrapper = modalContent.querySelector('.swiper-wrapper');
  swiperWrapper.innerHTML = ''; 
  productImages.forEach(image => {
    const slide = document.createElement('div');
    slide.className = 'swiper-slide item item-modal';
    slide.innerHTML = `<img src="${image}" class="struct" alt="${productTitle}">`;
    swiperWrapper.appendChild(slide);
  });

  const titleElement = modalContent.querySelector('.modal-slider-title');
  const priceElement = modalContent.querySelector('.modal-slider-pricing p');
  const descriptionElement = modalContent.querySelector('.description-item-modal h2');
  const descriptionContainer = modalContent.querySelector('.description-container');

  if (titleElement) titleElement.textContent = productTitle;
  if (priceElement) priceElement.textContent = productPrice;
  if (descriptionElement) descriptionElement.textContent = productDescription;
  /*
  const detailsBox = document.createElement('div');
  detailsBox.className = 'details-box';
  detailsBox.innerHTML = `
    <div class="origin">
      <h2 class="dropdown-title modal-slider-title">Description</h2>
      <div class="product-description dropdown-content description-item-modal">
          <p>${productDescription}</p>
      </div>
    </div>
  `;
  descriptionContainer.appendChild(detailsBox);
  */
  const blocks = [
    { type: 'collapsible_tab', settings: { heading: 'Shipping & Returns', content: shippingAndReturns } },
    { type: 'collapsible_tab', settings: { heading: 'Care Instructions', content: careInstructions } },
    { type: 'collapsible_tab', settings: { heading: 'Materials', content: materials } }
  ];

  blocks.forEach(block => {
    if (block.type === 'collapsible_tab') {
      const blockElement = document.createElement('div');
      blockElement.className = 'details-box';
      blockElement.innerHTML = `
        <div class="origin">
          <h2 class="dropdown-title modal-slider-title">${block.settings.heading}</h2>
          <div class="dropdown-content description-item-modal" style="display: none;">
            <p>${block.settings.content}</p>
          </div>
        </div>
      `;
      descriptionContainer.appendChild(blockElement);
    }
  });


  // Seleccionamos todos los elementos con la clase 'dropdown-title'
  const dropdownTitles = modalContent.querySelectorAll('.dropdown-title');

  // Mostramos el primer dropdown-content por defecto
  const firstContent = modalContent.querySelector('.product-description.dropdown-content');
  if (firstContent) {
      firstContent.style.display = 'block';
  }

  dropdownTitles.forEach(function(title) {
      title.addEventListener('click', function() {
          console.log('click');
          console.log('title', title);
          // Encontramos el contenido de dropdown asociado al título
          const content = title.nextElementSibling; // Debería ser .dropdown-content
          console.log('content', content);
          if (content && content.classList.contains('dropdown-content')) {
              // Alternamos la visibilidad del contenido
              if (content.style.display === 'none' || content.style.display === '') {
                  content.style.display = 'block'; // Muestra el contenido
              } else {
                  content.style.display = 'none'; // Oculta el contenido
              }
          }
      });
  });
}
function closeModal() {
  modal.classList.remove('open');
  checkout.classList.remove('hidden-checkout');
  if (document.body.style.overflow === 'hidden') {
    document.body.style.overflow = '';
  }
}

function initializeSwiper() {
  new Swiper('.swiper-container', {
    slidesPerView: 1,
    pagination: {
      el: ".swiper-pagination",
      type: "progressbar",
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
}

closeButton.addEventListener('click', closeModal);
modal.addEventListener('click', (event) => {
  if (event.target === modal) {
    closeModal();
  }
});